<template>
  <div class="loading" v-show="show">
    <img src="@assets/img/common/loading.svg" alt="loading">
  </div>
</template>

<script>
export default {
  name: 'loading',
  data() {
    return {
      show: true
    }
  },
  methods: {
    open(m) {
      this.show = true
    },
    close() {
      this.show = false
    }
  }
}
</script>

<style lang="less" scoped>
  .loading {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    width: 80px;
    height: 80px;
    z-index: 2000;
    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }
</style>
